import React, { Component, createRef } from "react";
import {
  Form,
  Icon,
  Input,
  Button,
  Alert,
  Tooltip,
  Select,
  TreeSelect,
  Row,
  Col,
  Tag,
  Popover,
  Modal
} from "antd";
import { notification, message } from "antd";
import { FormItemProps, FormCreateOption } from "antd/lib/form";
import TestSuiteInput from "../TestCaseAdd/TestSuiteInput";
import {
  Actions,
  TestCaseManageContext
} from "../TestCaseManagePageNew/TestCaseIndex";
import TestCaseQuickExtraFields from "./TestCaseQuickExtraFieldForm";
import { CustomField } from "../../services/generated-sdk";
import { CompanyPlan } from "../../services/generated-sdk/models/CompanyPlan";
import TestCasePriority from "./TestCasePriority";

const FormItem = Form.Item;
const TreeNode = TreeSelect.TreeNode;

const _ = require("lodash");

interface Props {
  showQuickAddForm: boolean;
  canAddTestCase: boolean;
  form: any;
  pushQuickAddTestCase: (values: Object) => void;
  switchQuickAddForm: (show: boolean) => void;
  suitesList: Array<any>;
  selectedSuite: object | boolean;
  projectId?: number;
  customFields: CustomField[];
  planDetails?: CompanyPlan;
}
class TestCaseQuickAddForm extends Component<Props> {
  constructor(props) {
    super(props);
  }
  static contextType = TestCaseManageContext;
  nameInput: Input | null = null;

  state = {
    suite: null,
    showExtraFields: false,
    title: "",
    requiredCfsPresent: false,
    priority: "1",
    tags: [],
    cfs: [],
    requiredCFS: [],
    CFValues: {},
    initValues: true,
    canShowCF: _.get(
      _.find(_.get(this.props, "planDetails.features", []), {
        name: "customfields"
      }),
      "allowed"
    ),
    tagsAllowed: _.get(
      _.find(_.get(this.props, "planDetails.features", []), {
        name: "tags"
      }),
      "allowed"
    )
  };

  componentDidMount() {
    if (this.props.selectedSuite) {
      // console.log("SELECTED", this.props.selectedSuite);
      this.props.form.setFieldsValue({
        suite: Number(this.props.selectedSuite["key"])
      });
    }
    this.setDefaultValues();
    const requiredCFS = [];
    if (this.nameInput) this.nameInput.focus();
    this.props.customFields.map(cf => {
      if (cf.isRequired) {
        requiredCFS.push(cf);
      }
    });
    if (requiredCFS.length) {
      this.setState({ requiredCfsPresent: true, requiredCFS });
    }
  }

  setDefaultValues = async () => {
    let customFieldsData = this.props.customFields.map(async cf => {
      let valueLabel = "";
      let color = "";
      let value =
        cf.type == "dropdown" || cf.type == "user" || cf.type == "number"
          ? null
          : "";
      // if (cf.type === "dropdown") {
      //   value = cf.extra.options[0].systemValue;
      //   valueLabel = cf.extra.options[0].label;
      //   color = cf.extra.options[0].color;
      // }
      if (cf.type === "user") {
        valueLabel = null;
      }
      if (cf.type === "date") {
        value = "";
        valueLabel = "";
        // value = Date();
        // valueLabel = Date();
        //valueLabel = Date("YYYY-MM-DD");
      }
      if (
        cf.type == "text" ||
        cf.type == "textarea" ||
        cf.type == "number" ||
        cf.type == "url"
      ) {
        value = "";
        valueLabel = "";
        if (cf.defaultValue != undefined) {
          value = cf.defaultValue;
          valueLabel = cf.defaultValue;
        }
      }
      return {
        id: cf.id,
        name: cf.name,
        value,
        label: cf.label,
        valueLabel,
        color
      };
      //} else {
      //return null;
    });
    const cfs = await Promise.all(customFieldsData);
    const values = cfs.filter(cf => cf != null);
    const CFValues = _.keyBy(values, "name");
    this.setState({ cfs: values, CFValues });
  };

  componentDidUpdate() {
    if (this.nameInput) this.nameInput.focus();
  }

  handleSubmit = e => {
    e.preventDefault();
    this.validateAndStore();
  };

  validateAndStore = () => {
    const {
      priority,
      initValues,
      tags,
      cfs,
      requiredCfsPresent,
      canShowCF
    } = this.state;

    this.props.form.validateFields((err, values) => {
      if (!err) {
        if (requiredCfsPresent && initValues && canShowCF) {
          this.setState({ showExtraFields: true });
          return;
        }

        this.props.pushQuickAddTestCase({
          ...values,
          priority,
          suite: this.props.selectedSuite
            ? this.props.selectedSuite["key"]
            : null,
          tags,
          cfs
        });
      } else {
        notification["error"]({
          message: "Error",
          description: "Please provide proper values"
        });
      }
    });
  };

  switchQuickAddForm = status => {
    if (status) {
      if (this.props.canAddTestCase == true) {
        this.props.switchQuickAddForm(status);
      } else {
        notification["error"]({
          message: "Error",
          description: "No Access"
        });
      }
    } else {
      this.props.switchQuickAddForm(status);
    }
    if (status) {
      this.props.form.resetFields(["title", "suite_id", "priority"]);
    }
  };

  handleModalFormSubmit = values => {
    const CFValues = _.keyBy(values.cfs, "name");
    this.setState(
      { ...values, showExtraFields: false, CFValues, initValues: false },
      this.validateAndStore
    );
  };

  showCustomFields = () => {
    const { cfs, requiredCFS, CFValues, canShowCF } = this.state;

    // const { customFields } = this.props;
    //console.log({ "custom fields data": cfs });
    if (!requiredCFS || !canShowCF) return <span>N/A</span>;
    if (requiredCFS && requiredCFS.length == 0) return <span>N/A</span>;
    return requiredCFS.map((customField, index) => {
      const cf = CFValues[customField.name];
      if (cf == null || !cf) {
        return null;
      } else {
        return (
          <div>
            <label>{cf.label}</label>: &nbsp;
            {cf.color ? (
              <Tag key={cf.id} color={cf.color}>
                {cf.valueLabel || cf.value || "NA"}
              </Tag>
            ) : (
              <span>{cf.valueLabel || cf.value || "NA"}</span>
            )}
          </div>
        );
      }
    });
  };

  render() {
    const { selectedSuite, form: { getFieldDecorator } } = this.props;
    const { canShowCF, tagsAllowed } = this.state;

    const quickaddfields = (
      <div>
        <p>
          Priority - <TestCasePriority priority={this.state.priority} />
          <br />
          Suite - {selectedSuite ? selectedSuite["title"] : "NA"}
          <br />
          Required Custom field -{this.showCustomFields()}
        </p>
        <Button
          onClick={() => {
            this.setState({ showExtraFields: true });
          }}
          type="primary"
          icon="edit"
          size="small"
        >
          Edit
        </Button>
      </div>
    );

    var addKeys = items => {
      _.forEach(items, function(item) {
        //prepare suites for SelectTree
        //if (item.type == "Suite") {
        item.label = item.title ? item.title.toString() : "";
        item.value = item.id ? item.id.toString() : "";
        //} else {
        //item.disabled = true;
        //}
        if (item.children) {
          addKeys(item.children);
        }
      });
    };

    addKeys(this.props.suitesList);

    return (
      <div style={{ padding: "10px 0" }}>
        <div
          style={
            this.props.showQuickAddForm
              ? { display: "block" }
              : { display: "none" }
          }
        >
          <Form
            onSubmit={this.handleSubmit}
            className="test-case-quick-add-form"
          >
            <Row gutter={24}>
              <Col className="gutter-row" span={22}>
                <div className="editable-cell">
                  <FormItem>
                    {getFieldDecorator("title", {
                      autofocus: true,
                      rules: [
                        {
                          required: true,
                          message: "Title cannot be left blank"
                        },
                        {
                          whitespace: true,
                          message: "Title cannot be left blank"
                        },
                        {
                          max: 250,
                          message: "Title cannot be more than 250 characters"
                        }
                      ]
                    })(
                      <Input
                        name="title"
                        //defaultValue={text}
                        autoFocus={true}
                        onChange={title => {
                          this.setState({ title });
                        }}
                        placeholder={"Your test case title"}
                        ref={input => {
                          this.nameInput = input;
                        }}
                        onPressEnter={this.handleSubmit}
                        suffix={
                          <Popover
                            content={quickaddfields}
                            title="Pre Defined Fields"
                          >
                            <Icon
                              type="info-circle"
                              style={{ color: "rgba(0,0,0,.45)" }}
                            />
                          </Popover>
                        }
                      />
                    )}
                  </FormItem>
                </div>
              </Col>

              <Col className="gutter-row" span={2}>
                <FormItem>
                  <Tooltip placement="bottom" title="Cancel">
                    <Button
                      shape="circle"
                      icon="close"
                      //htmlType="submit"
                      className="login-form-button"
                      onClick={() => this.switchQuickAddForm(false)}
                    />
                  </Tooltip>
                </FormItem>
              </Col>
            </Row>
          </Form>
        </div>

        <Modal
          visible={this.state.showExtraFields}
          onCancel={() => {
            this.setState({ showExtraFields: false });
          }}
          destroyOnClose
          footer={null}
        >
          <TestCaseQuickExtraFields
            suite={selectedSuite["key"]}
            project={this.props.projectId}
            title={this.state.title}
            customFields={this.props.customFields}
            handleCancel={() => {
              this.setState({ showExtraFields: false });
            }}
            priority={this.state.priority}
            tags={this.state.tags}
            cfs={this.state.cfs}
            CFValues={this.state.CFValues}
            pushQuickAddTestCase={this.handleModalFormSubmit}
            canShowCF={canShowCF}
            tagsAllowed={tagsAllowed}
          />
        </Modal>
        <Tooltip placement="right" title="Quick add test case">
          <Button
            icon="plus"
            type="primary"
            onClick={() => this.switchQuickAddForm(true)}
            disabled={!this.props.canAddTestCase}
            style={
              this.props.showQuickAddForm
                ? { display: "none" }
                : { display: "block" }
            }
          />
        </Tooltip>
      </div>
    );
  }
}

const mapPropsToFields = { mapPropsToFields(props: Props) {} };
const FormOptions: FormCreateOption<Props> = mapPropsToFields;

const TestCaseQuickAddModal = Form.create(FormOptions)(TestCaseQuickAddForm);
export default TestCaseQuickAddModal;
